import axiosClient, { unwrap } from "./axiosClient";

const managerPath = "/api/order-manager/liquor-orders";
const reviewPath = "/api/admin/liquor-orders";

export const liquorOrderApi = {
  waitingForStock: () => axiosClient.get(`${managerPath}/waiting-for-stock`).then(unwrap),
  receive: (id, supplierInvoiceNumber) => axiosClient.post(`${managerPath}/${id}/receive`, { supplierInvoiceNumber }).then(unwrap),
  receivingCorrections: (id) => axiosClient.get(`${managerPath}/${id}/receiving-corrections`).then(unwrap),
  requestReceivingCorrection: (id, reason) => axiosClient.post(`${managerPath}/${id}/receiving-correction`, { reason }).then(unwrap),
  suppliers: () => axiosClient.get(`${managerPath}/suppliers`).then(unwrap),
  catalog: (companyId, search) => axiosClient.get(`${managerPath}/catalog`, { params: { companyId, search } }).then(unwrap),
  myOrders: (params = {}) => axiosClient.get(managerPath, { params }).then(unwrap),
  myOrder: (id) => axiosClient.get(`${managerPath}/${id}`).then(unwrap),
  create: (data) => axiosClient.post(managerPath, data).then(unwrap),
  update: (id, data) => axiosClient.put(`${managerPath}/${id}`, data).then(unwrap),
  remove: (id) => axiosClient.delete(`${managerPath}/${id}`).then(unwrap),
  submit: (id) => axiosClient.post(`${managerPath}/${id}/submit`).then(unwrap),
  placeOrder: (id) => axiosClient.post(`${managerPath}/${id}/place`).then(unwrap),
  priceChanges: (id) => axiosClient.get(`${managerPath}/${id}/price-changes`).then(unwrap),
  refreshPrices: (id) => axiosClient.post(`${managerPath}/${id}/refresh-prices`).then(unwrap),
  reviewList: (params = {}) => axiosClient.get(reviewPath, { params }).then(unwrap),
  pendingReceivingCorrections: () => axiosClient.get(`${reviewPath}/receiving-corrections`).then(unwrap),
  approveReceivingCorrection: (id, reviewNote) => axiosClient.post(`${reviewPath}/receiving-corrections/${id}/approve`, { reviewNote }).then(unwrap),
  rejectReceivingCorrection: (id, reviewNote) => axiosClient.post(`${reviewPath}/receiving-corrections/${id}/reject`, { reviewNote }).then(unwrap),
  reviewDetail: (id) => axiosClient.get(`${reviewPath}/${id}`).then(unwrap),
  reviewReceivingCorrections: (id) => axiosClient.get(`${reviewPath}/${id}/receiving-corrections`).then(unwrap),
  reviewReceivingCorrections: (id) => axiosClient.get(`${reviewPath}/${id}/receiving-corrections`).then(unwrap),
  approve: (id, note) => axiosClient.post(`${reviewPath}/${id}/approve`, { note }).then(unwrap),
  reject: (id, note) => axiosClient.post(`${reviewPath}/${id}/reject`, { note }).then(unwrap),
  requestChanges: (id, note) => axiosClient.post(`${reviewPath}/${id}/request-changes`, { note }).then(unwrap),
  confirmBankTransfer: (id, data) => axiosClient.post(`${reviewPath}/${id}/confirm-bank-transfer`, data).then(unwrap),
  sendToSupplier: (id) => axiosClient.post(`${reviewPath}/${id}/send-to-supplier`).then(unwrap),
  orderPdf: async (id, audience = "manager") => {
    const basePath = audience === "admin" ? reviewPath : managerPath;
    try {
      const response = await axiosClient.get(`${basePath}/${id}/pdf`, { responseType: "blob" });
      return response.data;
    } catch (error) {
      const data = error.response?.data;
      if (data instanceof Blob) {
        let message;
        try {
          const body = JSON.parse(await data.text());
          message = body.message || body.detail;
        } catch { /* Keep the endpoint-level fallback for non-JSON errors. */ }
        throw new Error(message || "Could not generate the purchase order PDF");
      }
      throw new Error(error.response?.data?.message || error.message || "Could not generate the purchase order PDF");
    }
  },
};
